"use client"

import {  Target, Star, Users, BarChart3 } from "lucide-react"
import DashboardLayout from "@/views/dashboard/DashboardLayout"
import { Link } from "react-router-dom"
import { Button } from "@/components/ui/common/Button"

export default function HRPage() {
  return (
    <DashboardLayout>
      <div className="p-6">
        <div className="space-y-8">
          <div className="  ">
       
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              <div className="p-4 border   bg-orange-50 border-orange-200">
                <div className="flex items-center mb-2">
                  <Target className="h-5 w-5 text-orange-600 mr-2" />
                  <h3 className="font-medium text-gray-900">Ocena kandydatów</h3>
                </div>
                <p className="text-sm text-gray-600 mb-3">System oceny i rankingu kandydatów</p>
                <Link to="#">
                  <Button variant="outline" size="sm" className="w-full border-gray-200 bg-white border-1">
                    Oceń kandydatów
                  </Button>
                </Link>
              </div>

              <div className="p-4 border   bg-blue-50 border-blue-200">
                <div className="flex items-center mb-2">
                  <Users className="h-5 w-5 text-blue-600 mr-2" />
                  <h3 className="font-medium text-gray-900">Analiza zespołu</h3>
                </div>
                <p className="text-sm text-gray-600 mb-3">Profil psychologiczny zespołu</p>
                <Link to="#">
                  <Button variant="outline" size="sm" className="w-full border-gray-200 bg-white border-1">
                    Analizuj zespół
                  </Button>
                </Link>
              </div>

              <div className="p-4 border   bg-purple-50 border-purple-200">
                <div className="flex items-center mb-2">
                  <Star className="h-5 w-5 text-purple-600 mr-2" />
                  <h3 className="font-medium text-gray-900">Baza kompetencji</h3>
                </div>
                <p className="text-sm text-gray-600 mb-3">Katalog kompetencji i umiejętności</p>
                <Link to="#">
                  <Button variant="outline" size="sm" className="w-full border-gray-200 bg-white border-1">
                    Przeglądaj kompetencje
                  </Button>
                </Link>
              </div>

              <div className="p-4 border   bg-green-50 border-green-200">
                <div className="flex items-center mb-2">
                  <BarChart3 className="h-5 w-5 text-green-600 mr-2" />
                  <h3 className="font-medium text-gray-900">Raporty rekrutacyjne</h3>
                </div>
                <p className="text-sm text-gray-600 mb-3">Szczegółowe raporty i analizy</p>
                <Link to="#">
                  <Button variant="outline" size="sm" className="w-full border-gray-200 bg-white border-1">
                    Generuj raporty
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
